import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/MM.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillInstagram,
  AiTwotoneMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { useLang } from "../../context/LanguageContext";
import { translations } from "../../translations";

function Home2() {
  const { lang } = useLang();
  const tr = translations[lang].home2;

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              {tr.letMe} <span className="purple"> {tr.introduce} </span> {tr.myself}
            </h1>
            <p className="home-about-body">{tr.intro}</p>
            <p className="home-about-body">{tr.approach}</p>
            <p className="home-about-body">
              {tr.stack.map((tech, i) => (
                <span key={tech}>
                  {i > 0 && " · "}
                  <i><b className="purple">{tech}</b></i>
                </span>
              ))}
            </p>
            <p className="home-about-body">{tr.philosophy}</p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" style={{ maxWidth: "80%" }} alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>{tr.findMeOn}</h1>
            <p>
              {tr.feelFree} <span className="purple">{tr.connect} </span>{tr.withMe}
            </p>
            <ul className="home-about-social-links">

              <li className="social-icons">
                <a
                  href="mailto:milevamatteo@gmail.com"
                  className="icon-colour  home-social-icons"
                >
                  <AiTwotoneMail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/matteo-mileva-05437033b"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/matteomileva/"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
                <li className="social-icons">
                <a
                  href="https://github.com/mattemile"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
